<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category mb-3 rounded-lg">
          <v-col cols="12">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  filled
                  v-model="ruleDetail.name"
                  background-color="#EDF2F7"
                  item-text="text"
                  item-value="value"
                  label="Tên gói khuyến mại"
                  placeholder="Nhập tên"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="w-100-percent">
                <v-menu
                  class="float-left"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  background-color="#EDF2F7"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      filled
                      class="mr-3 float-left"
                      background-color="#EDF2F7"
                      v-model="start_date"
                      label="Thời gian bắt đầu"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" class="w-100-percent">
                <v-menu
                  class="float-left"
                  v-model="menu2"
                  background-color="#EDF2F7"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      filled
                      background-color="#EDF2F7"
                      class="mr-3 float-left"
                      v-model="end_date"
                      label="Thời gian kết thúc"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  type="number"
                  v-model="ruleDetail.priority"
                  background-color="#EDF2F7"
                  filled
                  label="Độ ưu tiên"
                  placeholder="Nhập độ ưu tiên"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="7">
                <v-select
                  filled
                  v-model="ruleDetail.rule_type"
                  :items="rule_types"
                  background-color="#EDF2F7"
                  item-text="text"
                  item-value="value"
                  label="Rule"
                  placeholder="Chọn rule"
                ></v-select>
              </v-col>
              <v-col cols="5">
                <v-select
                  filled
                  :items="brandsSelect"
                  background-color="#EDF2F7"
                  v-model="brand_id"
                  item-text="name"
                  item-value="id"
                  label="Nhãn hàng"
                  placeholder="Chọn nhãn hàng"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="ml-3">
            <v-row>
              <p>Hiển thị</p>
              <input
                class="checkbox ml-2 mt-1"
                type="checkbox"
                v-model="checked"
              />
            </v-row>
          </v-col>
          <v-col v-show="ruleDetail.rule_type == 1">
            <v-col cols="12" class="content_category mr-2 rounded-lg">
                <v-row>
                  <h3 class="mt-2">Số lượng sản phẩm</h3>
                  <v-btn
                    class="ml-5 mb-5"
                    color="primary"
                    @click="addNumberProduct()"
                  >
                    Thêm
                  </v-btn>
                </v-row>
                <v-row>
                  <v-divider></v-divider>
                </v-row>
                <v-row>
                  <div
                    class="content_property mt-5 rounded-lg w-100-percent"
                    v-for="(item, index) in rule1"
                    :key="index"
                  >
                    <v-row>
                      <v-col cols="2">
                        <vuetify-money
                          v-model="item.start"
                          v-bind:label="lableStart"
                          v-bind:placeholder="placeHolder"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="options"
                        />
                      </v-col>
                      <v-col cols="2">
                        <vuetify-money
                          v-model="item.end"
                          v-bind:label="lableEnd"
                          v-bind:placeholder="placeHolder"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="options"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-select
                          filled
                          v-model="item.type"
                          :items="types"
                          background-color="#EDF2F7"
                          item-text="text"
                          item-value="value"
                          label="Chọn loại"
                          placeholder="Chọn loại"
                        ></v-select>
                      </v-col>
                      <v-col cols="2">
                        <vuetify-money v-if="item.type == 1"
                          v-model="item.price"
                          v-bind:label="lablePrice"
                          v-bind:placeholder="placeHolder"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="optionsPercent"
                        />
                        <vuetify-money v-else
                          v-model="item.price"
                          v-bind:label="lablePrice"
                          v-bind:placeholder="placeHolder"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="options"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          filled
                          v-model="item.content"
                          background-color="#EDF2F7"
                          item-text="text"
                          item-value="value"
                          label="Nội dung khuyến mại"
                          placeholder="Nội dung khuyến mại"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="pl-0">
                        <v-btn
                          class="ml-0 mb-1 mt-2"
                          color="primary"
                          @click="clearNumberProduct(index)"
                        >
                          Xóa
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-row>
            </v-col>
          </v-col>

          <v-col v-show="ruleDetail.rule_type == 4">
            <v-col cols="12" class="content_category mr-2 rounded-lg">
                <v-row>
                  <h3 class="mt-2">Dòng sản phẩm</h3>
                  <v-btn
                    class="ml-5 mb-5"
                    color="primary"
                    @click="addCategoryMain()"
                  >
                    Thêm
                  </v-btn>
                  </v-row>
                  <v-row>
                    <v-divider></v-divider>
                  </v-row>
                  <v-row>
                  <div
                    class="content_property mt-5 rounded-lg w-100-percent"
                    v-for="(item, index) in rule4"
                    :key="index"
                  >
                    <v-row>
                      <v-col cols="2">
                        <vuetify-money
                          v-model="item.start"
                          label="Số dòng"
                          placeholder="Số dòng"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="options"
                        />
                      </v-col>
                      <v-col cols="2" v-show="false">
                        <vuetify-money
                          v-model="item.end"
                          v-bind:label="lableEnd"
                          v-bind:placeholder="lableEnd"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="options"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-select
                          filled
                          v-model="item.type"
                          :items="types"
                          background-color="#EDF2F7"
                          item-text="text"
                          item-value="value"
                          label="Chọn loại"
                          placeholder="Chọn loại"
                        ></v-select>
                      </v-col>
                      <v-col cols="2">
                        <vuetify-money v-if="item.type == 1"
                          v-model="item.price"
                          v-bind:label="lablePrice"
                          v-bind:placeholder="placeHolder"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="optionsPercent"
                        />
                        <vuetify-money v-else
                          v-model="item.price"
                          v-bind:label="lablePrice"
                          v-bind:placeholder="placeHolder"
                          v-bind:readonly="readonly"
                          v-bind:backgroundColor="backgroundColor"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                          v-bind:options="options"
                        />
                      </v-col>
                      <v-col cols="5">
                        <v-text-field
                          filled
                          v-model="item.content"
                          background-color="#EDF2F7"
                          item-text="text"
                          item-value="value"
                          label="Nội dung khuyến mại"
                          placeholder="Nội dung khuyến mại"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="pl-0">
                        <v-btn
                          class="ml-0 mb-1 mt-2"
                          color="primary"
                          @click="clearCategoryMain(index)"
                        >
                          Xóa
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  </v-row>
            </v-col>
          </v-col>
          <v-col v-show="ruleDetail.rule_type == 2">
            <v-col cols="12" class="content_category mr-2 rounded-lg">
              <v-row>
                <h3 class="mt-2">Giá sản phẩm</h3>
                <v-btn
                  class="ml-5 mb-5"
                  color="primary"
                  @click="addPriceProduct()"
                >
                  Thêm
                </v-btn>
              </v-row>
              <v-row>
                <v-divider></v-divider>
              </v-row>
              <v-row>
                <div
                  class="content_property mt-5 rounded-lg w-100-percent"
                  v-for="(item, index) in rule2"
                  :key="index"
                >
                  <v-row>
                    <v-col cols="2">
                      <vuetify-money
                        v-model="item.start"
                        v-bind:label="lableStart"
                        v-bind:placeholder="placeHolder"
                        v-bind:readonly="readonly"
                        v-bind:backgroundColor="backgroundColor"
                        v-bind:disabled="disabled"
                        v-bind:outlined="outlined"
                        v-bind:clearable="clearable"
                        v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                        v-bind:options="options"
                      />
                    </v-col>
                    <v-col cols="2">
                      <vuetify-money
                        v-model="item.end"
                        v-bind:label="lableEnd"
                        v-bind:placeholder="placeHolder"
                        v-bind:readonly="readonly"
                        v-bind:backgroundColor="backgroundColor"
                        v-bind:disabled="disabled"
                        v-bind:outlined="outlined"
                        v-bind:clearable="clearable"
                        v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                        v-bind:options="options"
                      />
                    </v-col>
                    <v-col cols="2">
                      <v-select
                        filled
                        v-model="item.type"
                        :items="types"
                        background-color="#EDF2F7"
                        item-text="text"
                        item-value="value"
                        label="Chọn loại"
                        placeholder="Chọn loại"
                      ></v-select>
                    </v-col>
                    <v-col cols="2">
                      <vuetify-money v-if="item.type == 1"
                        v-model="item.price"
                        v-bind:label="lablePrice"
                        v-bind:placeholder="placeHolder"
                        v-bind:readonly="readonly"
                        v-bind:backgroundColor="backgroundColor"
                        v-bind:disabled="disabled"
                        v-bind:outlined="outlined"
                        v-bind:clearable="clearable"
                        v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                        v-bind:options="optionsPercent"
                      />
                      <vuetify-money v-else
                        v-model="item.price"
                        v-bind:label="lablePrice"
                        v-bind:placeholder="placeHolder"
                        v-bind:readonly="readonly"
                        v-bind:backgroundColor="backgroundColor"
                        v-bind:disabled="disabled"
                        v-bind:outlined="outlined"
                        v-bind:clearable="clearable"
                        v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                        v-bind:options="options"
                      />
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        filled
                        v-model="item.content"
                        background-color="#EDF2F7"
                        item-text="text"
                        item-value="value"
                        label="Nội dung khuyến mại"
                        placeholder="Nội dung khuyến mại"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1" class="pl-0">
                      <v-btn
                        class="ml-0 mb-1 mt-2"
                        color="primary"
                        @click="clearPriceProduct(index)"
                      >
                        Xóa
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-row>
            </v-col>
          </v-col>
          <v-col v-show="ruleDetail.rule_type == 3">
            <v-col cols="12" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-row>
                  <h3 class="mt-2">Danh mục</h3>
                  <v-btn
                    class="ml-5 mb-5"
                    color="primary"
                    @click="addCategory()"
                  >
                    Thêm
                  </v-btn>
                </v-row>
                <v-col>
                  <v-divider></v-divider>
                  <div
                    class="content_property mt-5 rounded-lg"
                    v-for="(item, index) in rule3"
                    :key="index"
                  >
                    <v-col>
                      <v-row>
                        <v-col cols="4">
                          <v-autocomplete
                            type="number"
                            background-color="#EDF2F7"
                            filled
                            :items="categories"
                            v-model="item.category_id"
                            item-text="name"
                            item-value="id"
                            label="Category"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            type="number"
                            v-model="item.percent"
                            background-color="#EDF2F7"
                            filled
                            label="Giảm giá(%)"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                          <v-btn
                            type="number"
                            class="ml-5 mb-1 mt-1"
                            color="primary"
                            @click="clearCategory(index)"
                          >
                            Xóa
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-col>
          <v-col cols="12" class="text-center mb-2">
            <v-btn width="130" color="primary" @click="save"> Lưu </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_BRAND } from "@/store/modules/brand";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import { GET_DETAIL_RULES, UPDATE_RULES } from "@/store/modules/promotion_gift";
import Vue from "vue";
import VuetifyMoney from "vuetify-money";
Vue.use(VuetifyMoney);

export default {
  data() {
    return {
      lablePrice: "Giảm giá",
      placeHolder: "Giảm giá",
      lableStart: "Từ",
      lableEnd: "Đến",
      backgroundColor: "#EDF2F7",
      readonly: false,
      disabled: false,
      outlined: true,
      clearable: true,
      valueWhenIsEmpty: "",
      options: {
        locale: "en-EN",
        prefix: "",
        suffix: "",
        length: 15,
        precision: 0,
      },
      optionsPercent: {
        locale: "en-EN",
        prefix: "",
        suffix: "",
        length: 4,
        precision: 1,
      },
      checked: "",
      menu1: false,
      menu2: false,
      types: [
        { text: "Theo %", value: 1 },
        { text: "Theo số tiền", value: 2 },
      ],
      rule_type: null,
      rule_types: [
        { text: "Khuyến mại dựa trên số lượng sản phẩm", value: 1 },
        { text: "Khuyến mại dựa trên số lượng sản phẩm theo dòng sản phẩm", value: 4 },
        { text: "Khuyến mại dựa trên giá sản phẩm", value: 2 },
        // { text: "Khuyến mại theo giảm giá hàng tháng theo danh muc", value: 3 },
      ],

      start_date: "",
      end_date: "",
      rule1: [],
      rule2: [],
      rule3: [],
      rule4: [],
      price: 0,
      brand_id: null,
      page: "Khuyến mại",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Khuyến mại/Quà tặng",
          disabled: true,
        },
        {
          text: "Khuyến mại",
          disabled: true,
        },
        {
          text: "Thêm khuyến mại",
          disabled: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      ruleDetail: "ruleDetail",
      brands: "brands",
      categories: "categories",
    }),
    brandsSelect() {
      let arr = [...this.brands];
      arr.unshift({ id: -1, name: "Chọn nhãn hàng" });
      return arr;
    },
    // brandsSelect() {
    //   let arr = [...this.brands];
    //   arr.unshift({ id: "-1", name: "Chọn tất cả" });
    //   return arr;
    // },
  },

  watch: {
    ruleDetail(val) {
      if (val.rule_type == 1) {
        this.rule1 = val.rule_property.rule;
      }
      if (val.rule_type == 2) {
        this.rule2 = val.rule_property.rule;
      }
      if (val.rule_type == 3) {
        this.rule3 = val.rule_property.rule;
        for (let rule of this.rule3) {
          rule.category_id = parseInt(rule.category_id);
        }
      }
      if (val.rule_type == 4) {
        this.rule4 = val.rule_property.rule;
      }
      this.start_date = val.start_date;
      this.end_date = val.end_date;
      this.brand_id = val.rule_property.brand_id;
      if (val.is_active == 0) {
        this.checked = false;
      }
      if (val.is_active == 1) {
        this.checked = true;
      }
    },
  },

  async created() {
    // this.url = process.env.VUE_APP_API_URL;
    await this.$store.dispatch(`${GET_DETAIL_RULES}`, this.$route.params.id);
    await this.$store.dispatch(GET_LIST_BRAND);
    await this.$store.dispatch(GET_LIST_CATEGORY);
  },
  methods: {
    formatDate(input) {
      var datePart = input.match(/\d+/g),
        year = datePart[0], // get only two digits
        month = datePart[1],
        day = datePart[2];
      return day + "/" + month + "/" + year;
    },
    save() {
      if(this.brand_id==-1){
        this.brand_id= null
      }
      let rule_form = null;
      if (this.ruleDetail.rule_type == 1) {
        let _rule_form = {
          rule: this.rule1,
          brand_id: this.brand_id,
        };
        rule_form = _rule_form;
      }
      if (this.ruleDetail.rule_type == 4) {
        let _rule_form = {
          rule: this.rule4,
          brand_id: this.brand_id
        };
        rule_form = _rule_form;
      }
      if (this.ruleDetail.rule_type == 2) {
        let _rule_form = {
          rule: this.rule2,
          brand_id: this.brand_id,
        };
        rule_form = _rule_form;
      }
      if (this.ruleDetail.rule_type == 3) {
        for (let rule of this.rule3) {
          rule.category_id = String(rule.category_id);
        }
        let _rule_form = {
          rule: this.rule3,
          brand_id: this.brand_id,
        };
        rule_form = _rule_form;
      }
      //   let startDate = this.formatDate()
      //   let endDate =
      let active = 1;
      if (!this.checked) {
        active = 0;
      }
      if (this.checked) {
        active = 1;
      }
      let formStartDate = "";
      let formEndDate = "";
      if (this.start_date != null && this.start_date.length > 0) {
        formStartDate = this.formatDate(this.start_date.replace(/-/gi, "/"));
      }
      if (this.end_date != null && this.end_date.length > 0) {
        formEndDate = this.formatDate(this.end_date.replace(/-/gi, "/"));
      }
      let rules_form = {
        id: this.ruleDetail.id,
        name: this.ruleDetail.name,
        rule_type: this.ruleDetail.rule_type,
        rule_property: JSON.stringify(rule_form),
        priority: parseInt(this.ruleDetail.priority),
        start_date: formStartDate,
        end_date: formEndDate,
        is_active: active,
      };
      this.$store.dispatch(`${UPDATE_RULES}`, rules_form).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push("/manage_promotion_gift/Manage_promotion");
        } else {
          alert(data.data.errors);
        }
      });
    },
    addNumberProduct() {
      this.rule1.push({
        start: null,
        end: null,
        price: null,
      });
    },
    clearNumberProduct(i) {
      this.rule1.splice(i, 1);
      this.$forceUpdate();
    },
    addPriceProduct() {
      this.rule2.push({
        start: null,
        end: null,
        price: null,
      });
    },
    clearPriceProduct(i) {
      this.rule2.splice(i, 1);
      this.$forceUpdate();
    },
    addCategory() {
      this.rule3.push({
        category_id: null,
        percent: null,
      });
    },
    clearCategory(i) {
      this.rule3.splice(i, 1);
      this.$forceUpdate();
    },
    addCategoryMain() {
      this.rule4.push({
        start: null,
        end: null,
        price: null,
      });
    },
    clearCategoryMain(i) {
      this.rule4.splice(i, 1);
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
.w-100-percent, .w-100-percent > .v-input{
  width: 100%;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
  .checkbox {
    height: 20px !important;
    width: 20px !important;
  }
  .contentx {
    background: !important;
  }
}
</style>
